<template>
  <div class="verifyDetail">
    <div class="mask"></div>
    <div v-if="dealState===0" class="verifyDetailMain">
      <p v-if="detailInfo.columnName!=='zp'" class="desc">
        审批编号：<span class="strong">{{detailInfo.id}}</span><br/>
        用户<span class="strong">{{detailInfo.username}}</span>正在修改<span class="strong">{{detailInfo.describe}}</span>信息，<br/>
        将 <span class="strong">{{detailInfo.oldVal}}</span>修改为<span class="strong">{{detailInfo.val}}</span><br/>
        修改原因：<span class="strong">{{detailInfo.reason?detailInfo.reason:'用户未填写'}}</span><br>
        是否审批通过？
      </p>
      <p v-if="detailInfo.columnName==='zp'" class="desc">
        审批编号：<span class="strong">{{detailInfo.id}}</span><br/>
        用户<span class="strong">{{detailInfo.username}}</span>正在修改<span class="strong">{{detailInfo.describe}}</span>信息，<br/>
        将 <img :src="detailInfo.oldVal" alt=""/>修改为<img :src="detailInfo.zp" alt=""/><br/>
        修改原因：<span class="strong">{{detailInfo.reason?detailInfo.reason:'用户未填写'}}</span>
      </p>
      <p class="desc">审批原因：</p>
      <textarea v-model="reason" class="reason"></textarea>
      <ul class="btnList">
        <li @click="agree">通过</li>
        <li @click="reject">驳回</li>
        <li @click="cancel">取消</li>
      </ul>
    </div>
    <div v-if="dealState!==0" class="verifyDetailMain">
      <div @click="cancel" class="close"><i class="iconfont icon-cha"></i></div>
      <p v-if="detailInfo.columnName!=='zp'" class="desc">
        审批编号：<span class="strong">{{detailInfo.id}}</span><br/>
        用户<span class="strong">{{detailInfo.username}}</span>正在修改<span class="strong">{{detailInfo.describe}}</span>信息，<br/>
        将 <span class="strong">{{detailInfo.oldVal}}</span>修改为<span class="strong">{{detailInfo.val}}</span><br/>
        修改原因：<span class="strong">{{detailInfo.reason?detailInfo.reason:'用户未填写'}}</span><br>
        是否审批通过？
      </p>
      <p v-if="detailInfo.columnName==='zp'" class="desc">
        审批编号：<span class="strong">{{detailInfo.id}}</span><br/>
        用户<span class="strong">{{detailInfo.username}}</span>正在修改<span class="strong">{{detailInfo.describe}}</span>信息，<br/>
        将 <img :src="detailInfo.oldVal" alt=""/>修改为<img :src="detailInfo.zp" alt=""/><br/>
        修改原因：<span class="strong">{{detailInfo.reason?detailInfo.reason:'用户未填写'}}</span>
      </p>
      <p class="desc">审批原因：{{detailInfo.content}}</p>

      <p class="dealResult agree" v-if="dealState===1">已通过</p>
      <p class="dealResult disagree" v-if="dealState===2">已驳回</p>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config'

  export default {
    name: "verifyDetail",
    data() {
      return {
        detailInfo:{},
        reason:null,
        dealState:null
      }
    },
    props:{
      currSelectId:{
        type:Number,
      }
    },
    computed: {},
    methods: {
      async _initDetail(){
        let detail = await axios.post(apiConfig.REQUEST_URL+'/ehall/front_getPersonInfo',{
          id:this.currSelectId
        })

        if(detail.data.status){
          this.detailInfo=detail.data.data[0]
          this.dealState=this.detailInfo.state
          return
          // 注释掉已处理状态自动退出
          // if(this.detailInfo.state!==0){
          //   this.$notify({
          //     group: 'global',
          //     title: '温馨提示',
          //     text: '当前审批您已经处理！'
          //   })
          //   this.cancel()
          // }
        }else{
          this.$notify({
            group: 'global',
            title: '温馨提示',
            text: detail.data.msg
          })
          this.cancel()
        }

      },
      cancel(){
        this.$emit('setIdNull')
      },
      agree(){
        this.$emit('setItemAgree',{item:this.detailInfo,reason:this.reason})
      },
      reject(){
        this.$emit('setItemReject',{item:this.detailInfo,reason:this.reason})
      },

    },
    mounted() {
      this._initDetail()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
.verifyDetail
  .mask
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    background rgba(0,0,0,0.5)
    width 100%
    height 100%
  .verifyDetailMain
    border-radius 10px
    overflow visible
    padding 20px
    color #666666
    font-size 14px
    box-shadow 3px 3px 3px #666
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    margin auto
    width 800px
    height 400px
    background #f1f1f1
    .close
      width 40px
      height 40px
      line-height 40px
      text-align center
      right -50px
      top -50px
      border-radius 50%
      background #f1f1f1
      box-shadow 3px 3px 3px #666
      position absolute
      i
        font-size 20px
    .desc
      line-height 40px
      .strong
        font-weight bold
        margin 0 5px
        color #004a94
      &>img
        width 64px
        margin 0 5px
        vertical-align middle
    .btnList
      margin-top 20px
      font-size 0
      text-align center
      li
        font-size 14px
        color #666666
        height 26px
        width 70px
        text-align center
        border-radius 13px
        border 1px solid #cccccc
        line-height 26px
        cursor pointer
        transition 300ms
        margin-right 5px
        display inline-block
        -webkit-user-select: none
        -moz-user-select: none
        -ms-user-select: none
        user-select: none
        &:hover
          background-color #eeeeee
  .reason
    width 100%
    margin-top 10px
    height 50px
    padding 5px
    font-family '微软雅黑'
    color #666666
    outline none
    border-radius 5px
    border 1px solid #cccccc
  .dealResult
    font-size 16px
    margin-top 40px
    line-height 40px
    text-align center
    &.agree
      color #439138
    &.disagree
      color #5e1823
</style>


// WEBPACK FOOTER //
// src/components/profileVerify/verifyDetail.vue